import React, { useState } from "react";
import styles from "../styles/Thank-you.module.css";
import FAQItem from "./FAQItem";
import { faqData } from '../data/faqData';

const FAQSection: React.FC = () => {
  const [visibleFAQs, setVisibleFAQs] = useState(5);

  const showMoreFAQs = () => {
    setVisibleFAQs(prevVisibleFAQs => prevVisibleFAQs + 5);
  };

  return (
    <section className={styles.faqSection}>
      <h2>Frequently Asked Questions</h2>
      <div className={styles.faqItems}>
        {faqData.slice(0, visibleFAQs).map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
      {visibleFAQs < faqData.length && (
        <button className={styles.seeMoreButton} onClick={showMoreFAQs}>See more</button>
      )}
    </section>
  );
};

export default FAQSection;
